import styled from 'styled-components';
import { hexToRgba } from '../../../utils/style';
import { StyleColor, Format, BaseStyledComponentProps } from '../../../utils/styles-constants';

interface StyledLeftSideMenuProps {
	isOpen: boolean;
}

interface HeaderMenuItemProps {
	hasProfile: boolean;
}

const menuWidth = '380px';
const menuWidthSmartphone = '300px';

const StyledLeftSideMenu = styled('div')`
	display: flex;
	flex-direction: column;
	position: absolute;
	top: 0;
	bottom: 0;
	margin: 0;
	background-color: ${StyleColor.White};
	overflow-x: hidden;
	overflow-y: auto;
	padding: 0;
	transition: left 0.2s;
	z-index: 11;
	color: ${StyleColor.Grey500};
	width: ${menuWidth};
	left: ${(props: StyledLeftSideMenuProps) => props.isOpen ? 0 : `-${menuWidth}`};

	@media ${Format.Smartphone} {
		width: ${menuWidthSmartphone};
		left: ${(props: StyledLeftSideMenuProps) => props.isOpen ? 0 : `-${menuWidthSmartphone}`};
	}
`;

const HeaderMenuItem = styled('div')`
	height: ${(props: HeaderMenuItemProps) => props.hasProfile ? 'auto' : '70px'};
	border-bottom: 1px solid ${StyleColor.Grey50};
	background-color: ${(props: BaseStyledComponentProps) => {
		const opacity = props.theme.primary.topnavOpacity ? props.theme.primary.topnavOpacity : 100;
		return hexToRgba(props.theme.primary.topnavColor, opacity);
	}};
	position: relative;
	margin-left: 0;
	padding-left: ${(props: HeaderMenuItemProps) => props.hasProfile ? '0' : '15px'};
	display: flex;
	align-items: center;
`;

const MenuItemsWrapper = styled('div')`
	flex: 1 0 auto;
`;

const UserInfoWrapper = styled('div')`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	width: 100%;
	padding: 20px;
`;

export { StyledLeftSideMenu, MenuItemsWrapper, HeaderMenuItem, UserInfoWrapper };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MenuManager/Left/styles.ts